// extracted by css-extract-rspack-plugin
export default {"money":"money-NhUoCZ text-base-regular","moneyInput":"moneyInput-LrT2RJ"};